import React from "react";
import AccessTypeFormContent from "../../../../../../components/common/PL/Forms/AccessTypeFormContent/AccessTypeFormContent";

type VisitorContentFormProps = {
  formId: string;
  authorizations?: any[];
  disabled?: boolean;
};

const VisitorContentForm: React.FC<VisitorContentFormProps> = ({
  formId: _formId,
  authorizations,
  disabled = false,
}) => (
  <AccessTypeFormContent fieldPrefix="visitor" authorizations={authorizations} disabled={disabled} />
);

export default VisitorContentForm;
